import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { enqueueSnackbar } from '../../../components/GlobalSnackbar/snackbarStore';
import { keys } from './keys';

type Variables = {
  spaceId: string;
  name: string;
};

async function createDocumentType(variables: Variables) {
  const { data, error } = await apiClient
    .from('document_types')
    .insert({
      space_id: variables.spaceId,
      name: variables.name.trim(),
    })
    .select()
    .single();

  if (error) {
    if (error.code === '23505') {
      throw new Error('Un type de document avec ce nom existe déjà.');
    }
    throw error;
  }

  return data;
}

export function useCreateDocumentType() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) => createDocumentType(variables),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.documents });
      enqueueSnackbar('Type de document créé avec succès.', 'success');
    },
    onError: (error: Error) => {
      enqueueSnackbar(error.message || 'Erreur lors de la création du type de document.', 'error');
    },
  });
}
